export const ESTATE_UNIT_FILTER_ALL = '';
export const ESTATE_UNIT_FILTER_NONE = 'null';

export const toEstateUnitIdQueryParam = (
  value: string
): string | undefined => {
  if (!value) {
    return undefined;
  }

  return value;
};

export const appendEstateUnitIdToFilter = <T extends Record<string, unknown>>(
  filter: T,
  estateUnitId: string
): T & { estateUnitId?: string } => {
  const queryValue = toEstateUnitIdQueryParam(estateUnitId);

  if (!queryValue) {
    return filter;
  }

  return {
    ...filter,
    estateUnitId: queryValue
  };
};

export const buildEstateUnitQueryString = (estateUnitId: string): string => {
  const queryValue = toEstateUnitIdQueryParam(estateUnitId);

  if (!queryValue) {
    return '';
  }

  return `&estateUnitId=${encodeURIComponent(queryValue)}`;
};

export const resolveEstateIdForUnitFilter = (
  selectedEstateIds?: string | string[],
  activeEstateId?: string | null
): string | undefined => {
  if (Array.isArray(selectedEstateIds)) {
    if (selectedEstateIds.length === 1) {
      return selectedEstateIds[0];
    }

    return activeEstateId ?? undefined;
  }

  return selectedEstateIds || activeEstateId || undefined;
};
